import percentageFormat from '@insided/control/utils/percentageFormat'
import classNames from 'classnames'
import Tooltip from '@insided/deprecated-control/ui-components/Tooltip'
import Icon from '@insided/deprecated-preact-components/assets'

export interface KeyInsightCardComparisonStatsProps {
  showComparisonUnavailable?: boolean
  percent?: number
  comparisonTooltip?: string
}

const KeyInsightCardComparisonStats = ({
  percent,
  comparisonTooltip,
  showComparisonUnavailable = false
}: KeyInsightCardComparisonStatsProps) => {
  const value = percent !== undefined ? percentageFormat(percent) : undefined

  return (
    <div className='metric-comparision'>
      {showComparisonUnavailable || percent === undefined ? (
        <div className='metric-percentage metric-text'> - </div>
      ) : (
        <div
          className={classNames({
            'metric-percentage': value !== '0%',
            'metric-percentage-negative': percent < 0,
            'metric-percentage-positive': percent > 0
          })}
        >
          {value}
        </div>
      )}
      <div className='metric-text'>vs previous period
        {comparisonTooltip && (
          <Tooltip
            position='right'
            trigger={<Icon width={16} height={16} icon='question' customClass='icon-previous-period-info' />}
            customClasses='metric-help-tooltip'
            tooltipMessage={comparisonTooltip}
          />
        )}
      </div>
    </div>
  )
}

export default KeyInsightCardComparisonStats
